<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:head-actions>
      <a href="create_new_purchase_order" class="btn btn-primary"
        >+ Create PO</a
      >
    </template>
    <template v-slot:table-heading>
      <th width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #ID
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        P.O Number
      </th>
      <th  width="20%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Supplier Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        P.O Status
      </th>
      <th  width="20%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Initiation Date
      </th>
      <!-- <th
          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
        >
          Gender
        </th> -->

      <th  width="25%" class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              {{ user.po_number }}
            </div>
          </div>
        </td>
        <td>
          {{ user.supplier_name }}
        </td>
        <td>
          {{ user.is_delivered == "1" ? "Delivered" : "In Waiting" }}
        </td>

        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            formatDateTime_int(user.order_date)
          }}</soft-badge>
        </td>

        <td class="align-middle">
          <a
            class="btn"
            :href="'/purchase_order/detail/' + user.id"
            style="
              border: 1px solid black;
              padding: 4px;
              margin: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
            >Open</a
          >

          <a
            class="btn"
            :href="'/purchase_order_delivered/detail/' + user.id"
            style="
              border: 1px solid black;
              padding: 4px;
              margin: 0;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
            >Process Delivery</a
          >
        </td>
      </tr>
    </template>
  </BaseLayout>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BaseLayout from "../Patients/components/table_page_layout.vue";
import formatDateTime from "../../timezone/utc_local_time.js";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search P.O No, Supplier...",
      searchUrl: "searchLPOs",
      mainUrl: "getCompanyLPOs",
    };
  },
  components: {
    BaseLayout,
    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
